import { render, staticRenderFns } from "./template.html?vue&type=template&id=4bff54c2&scoped=true&"
import script from "./instructions_header_image_two_button.vue?vue&type=script&lang=js&"
export * from "./instructions_header_image_two_button.vue?vue&type=script&lang=js&"
import style0 from "./instructions_header_image_two_button.vue?vue&type=style&index=0&id=4bff54c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff54c2",
  null
  
)

export default component.exports